const publicListingsReducer = (state = {}, action) => {
  switch (action.type) {
  case 'GET_PUBLIC_LISTINGS':
    if (action.error) return state;
    return { data: action.data.data };

  default:
    return state;
  }
};

export default publicListingsReducer;
